// Keep the formatted Persian amount intact while placing its trailing currency
// unit visually on the left, even inside Highcharts LTR SVG/HTML containers.
function rtlChartAmount(formatted) {
  return '\u202b' + formatted + '\u202c';
}
module.exports = { rtlChartAmount };
